export type UnreadChatMessage = {
  timestamp: number;
  from?: { isLocal?: boolean; name?: string; identity?: string };
  message?: string;
  id?: string;
};

export function countUnreadRemoteMessages(
  messages: UnreadChatMessage[],
  lastReadAt: number,
): number {
  return messages.filter((msg) => !msg.from?.isLocal && (!lastReadAt || msg.timestamp > lastReadAt))
    .length;
}

export function latestRemoteMessage(messages: UnreadChatMessage[]): UnreadChatMessage | undefined {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const msg = messages[i];
    if (msg && !msg.from?.isLocal) return msg;
  }
  return undefined;
}

export function chatMessageNotifyId(message: UnreadChatMessage): string {
  return message.id ?? String(message.timestamp);
}

export function chatMessagePreview(message: UnreadChatMessage, maxLength = 140): string {
  return (message.message ?? '').trim().slice(0, maxLength);
}

export function shouldNotifyChatMessage(options: {
  chatOpen: boolean;
  lastReadAt: number;
  alreadyNotified: boolean;
  message?: UnreadChatMessage;
}): boolean {
  const { chatOpen, lastReadAt, alreadyNotified, message } = options;
  if (chatOpen || alreadyNotified || !message || message.from?.isLocal) return false;
  if (lastReadAt && message.timestamp <= lastReadAt) return false;
  return true;
}

export function remoteMessagesToNotify(
  messages: UnreadChatMessage[],
  options: { chatOpen: boolean; lastReadAt: number; notifiedIds: Set<string> },
): UnreadChatMessage[] {
  if (options.chatOpen) return [];
  return messages.filter((message) =>
    shouldNotifyChatMessage({
      chatOpen: false,
      lastReadAt: options.lastReadAt,
      alreadyNotified: options.notifiedIds.has(chatMessageNotifyId(message)),
      message,
    }),
  );
}
